@if (!isCwKWeb) {
  <div class="alert alert-danger fs-1 m-5 p-5 text-center">
    Attention: this page illegally copies parts or all of the Code&nbsp;Race.org website! Please copy<br/>
    <br/>
    <b>www.coderace.org</b><br/>
    <br/>
    to your browser's address bar to continue to the official Code&nbsp;Race.org website.<br/>
  </div>
} @else {

  <div class="container">

    <!-- Header of the page -->
    <cr-page-header>
      <ng-container>
        <div class="d-flex flex-row align-items-center justify-content-end">
          @if (isLocaleEn) {
            <cr-header-menu [activeTab]="activeTab" ownTabs=""></cr-header-menu>
          }
        </div>
      </ng-container>
    </cr-page-header>

    <!-- Content of the view -->
    <div class="router-outlet">
      <router-outlet></router-outlet>
    </div>

    <!-- Footer of the page -->
    <cr-page-footer></cr-page-footer>

    <!-- Cookie consent manager -->
    <shared-cookie-consent-manager></shared-cookie-consent-manager>
  </div>
}
